import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Function to check auth status
  const checkAuthStatus = () => {
    const token = localStorage.getItem('faheem_token');
    setIsAuthenticated(!!token);
  };

  useEffect(() => {
    // Initial check
    checkAuthStatus();

    // Listen for storage changes (when another tab/window changes localStorage)
    const handleStorageChange = (e) => {
      if (e.key === 'faheem_token' || e.key === null) {
        checkAuthStatus();
      }
    };

    // Listen for custom auth events (when this tab changes auth state)
    const handleAuthChange = () => {
      checkAuthStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('authChange', handleAuthChange);

    // Set up interval to periodically check auth status (as backup)
    const interval = setInterval(checkAuthStatus, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authChange', handleAuthChange);
      clearInterval(interval);
    };
  }, []);

  const logout = () => {
    // Clear all auth-related items from localStorage
    localStorage.removeItem('faheem_token');
    localStorage.removeItem('faheem_auth');
    localStorage.removeItem('faheem_user');
    localStorage.removeItem('faheem_role');
    
    setIsAuthenticated(false);
    
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event('authChange'));
    
    // Redirect to home page
    navigate('/');
  };

  return { isAuthenticated, logout };
};
